import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ImageuploadService {
private Img = new BehaviorSubject<string>('0');
private Img1 = new BehaviorSubject<string>('0');
private Img2 = new BehaviorSubject<string>('0');
ImageUplode = this.Img.asObservable();
ImageUplode1 = this.Img1.asObservable();
ImageUplode2 = this.Img2.asObservable();
constructor() {
}
ImageUploader(newImage) {
//  debugger
  this.Img.next(newImage);
}
ImageUploader1(newImage) {
  //  debugger
    this.Img1.next(newImage);
  }
  ImageUploader2(newImage) {
    //  debugger
      this.Img2.next(newImage);
    }
}

     



    
